import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Element from '../../../Components/SelectElement/Element';
import { setFormSelectItem, setFormState } from '../../../redux/form';
import { closeModal } from '../../../redux/modal';
import { numberAddComma } from '../../../common/util';
import DefaultModalLayout from './../../../Layouts/ModalLayouts/DefaultModalLayout';
import { FuneralItemTypes } from './../../../redux/funeralItem';
import { FormTypes } from './../../../redux/form';

const key = 'moveOption';
function SelectMove() {
    const dispatch = useDispatch();
    const moveOptions = useSelector(
        (state) => state.funeralItem[FuneralItemTypes.OPTIONS].moveOption
    );
    const { moveOptionId } = useSelector(
        (state) => state.form[FormTypes.FUNERAL_ESTIMATE]
    );

    return (
        <DefaultModalLayout header={{ content: '운구 선택', props: {} }}>
            {moveOptions.map((ele, idx) => {
                const {
                    optionId,
                    name,
                    extra,
                    price,
                    default: IsDefault,
                } = ele;

                return (
                    <Element
                        key={optionId}
                        name={name}
                        extra={<>{numberAddComma(price)}원</>}
                        selected={optionId === moveOptionId}
                        onClick={() => {
                            dispatch(
                                setFormState({
                                    type: FormTypes.FUNERAL_ESTIMATE,
                                    prop: key + 'Id',
                                    data: optionId,
                                })
                            );
                            dispatch(
                                setFormSelectItem({
                                    type: FormTypes.FUNERAL_ESTIMATE,
                                    prop: key,
                                    data: ele,
                                })
                            );
                            dispatch(closeModal());
                        }}
                    />
                );
            })}
        </DefaultModalLayout>
    );
}

export default SelectMove;
